'use strict';

//-------------------------------------------------------
// INIT
//-------------------------------------------------------
jQuery(document).ready(function () {
  new Navigation();
});


//-------------------------------------------------------
// CLASS
//-------------------------------------------------------
function Navigation()
{
  let self = this;
  this.scrollOld = 0;
  this.scrollingUp = 0;

  this.init = function () {
    self.header = document.getElementById('navigation');
    self.navPrimary = document.getElementById('nav-primary');
    self.toggleOpen = document.getElementById('toggle-open');
    self.toggleClose = document.getElementById('toggle-close');
    self.eventListeners();
  };

  this.eventListeners = function () {

    self.toggleOpen.addEventListener('click', function(){
      self.open();
    });

    self.toggleClose.addEventListener('click', function(){
      self.close();
    });

    window.addEventListener('scroll', function() {
      self.sticky();
    });
  };

  this.open = function() {
    self.navPrimary.classList.add('open');
  };

  this.close = function() {
    self.navPrimary.classList.remove('open');
  };

  this.sticky = function() {
    self.scroll = self.scrollTop();
    self.scrollingUp = (self.scrollOld > self.scroll);
    self.scrollOld = self.scroll;

    if(self.scroll >= 10)
      self.header.classList.add('active');

    if(self.scroll >= 100)
      self.header.classList.add('sticky');
    if(self.scroll < 100)
      self.header.classList.remove('sticky');

    if(self.scroll >= 500 && !self.scrollingUp)
      self.header.classList.add('slim');
    if(self.scroll < 500 || self.scrollingUp)
      self.header.classList.remove('slim');
  };

  this.scrollTop = function() {
    return (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
  };

  self.init();
}



// WEBPACK FOOTER //
// ./scripts/misc/navigation.js